// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/maintenance.proto (package tickettally.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/maintenance.proto.
 */
export const file_v1_maintenance: GenFile = /*@__PURE__*/
  fileDesc("ChR2MS9tYWludGVuYW5jZS5wcm90bxIOdGlja2V0dGFsbHkudjEiUgoQTWFpbnRlbmFuY2VTdGF0ZRIPCgdlbmFibGVkGAEgASgIEgwKBGZyb20YAiABKAkSCgoCdG8YAyABKAkSEwoLZW52aXJvbm1lbnQYBCABKAkiFwoVR2V0TWFpbnRlbmFuY2VSZXF1ZXN0IkkKFkdldE1haW50ZW5hbmNlUmVzcG9uc2USLwoFc3RhdGUYASABKAsyIC50aWNrZXR0YWxseS52MS5NYWludGVuYW5jZVN0YXRlIkUKGFVwZGF0ZU1haW50ZW5hbmNlUmVxdWVzdBIPCgdlbmFibGVkGAEgASgIEgwKBGZyb20YAiABKAkSCgoCdG8YAyABKAkiTAoZVXBkYXRlTWFpbnRlbmFuY2VSZXNwb25zZRIvCgVzdGF0ZRgBIAEoCzIgLnRpY2tldHRhbGx5LnYxLk1haW50ZW5hbmNlU3RhdGUy3wEKEk1haW50ZW5hbmNlU2VydmljZRJfCg5HZXRNYWludGVuYW5jZRIlLnRpY2tldHRhbGx5LnYxLkdldE1haW50ZW5hbmNlUmVxdWVzdBomLnRpY2tldHRhbGx5LnYxLkdldE1haW50ZW5hbmNlUmVzcG9uc2USaAoRVXBkYXRlTWFpbnRlbmFuY2USKC50aWNrZXR0YWxseS52MS5VcGRhdGVNYWludGVuYW5jZVJlcXVlc3QaKS50aWNrZXR0YWxseS52MS5VcGRhdGVNYWludGVuYW5jZVJlc3BvbnNlQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM");

/**
 * MaintenanceState is the maintenance window as stored in Remote Config for
 * the environment the backend is running in.
 *
 * @generated from message tickettally.v1.MaintenanceState
 */
export type MaintenanceState = Message<"tickettally.v1.MaintenanceState"> & {
  /**
   * Master switch. When false the window is irrelevant.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * Inclusive start, ISO 8601 with a UTC offset (e.g. 2026-09-12T02:00:00+07:00).
   * Empty means the maintenance starts as soon as it is enabled.
   *
   * @generated from field: string from = 2;
   */
  from: string;

  /**
   * Inclusive end, same format. Empty means no planned end.
   *
   * @generated from field: string to = 3;
   */
  to: string;

  /**
   * Which environment this state belongs to: "dev", "prod" or "local".
   * Read-only; set by the server from its own configuration so the admin
   * screen can name what it is about to take down.
   *
   * @generated from field: string environment = 4;
   */
  environment: string;
};

/**
 * Describes the message tickettally.v1.MaintenanceState.
 * Use `create(MaintenanceStateSchema)` to create a new message.
 */
export const MaintenanceStateSchema: GenMessage<MaintenanceState> = /*@__PURE__*/
  messageDesc(file_v1_maintenance, 0);

/**
 * GetMaintenanceRequest
 *
 * @generated from message tickettally.v1.GetMaintenanceRequest
 */
export type GetMaintenanceRequest = Message<"tickettally.v1.GetMaintenanceRequest"> & {
};

/**
 * Describes the message tickettally.v1.GetMaintenanceRequest.
 * Use `create(GetMaintenanceRequestSchema)` to create a new message.
 */
export const GetMaintenanceRequestSchema: GenMessage<GetMaintenanceRequest> = /*@__PURE__*/
  messageDesc(file_v1_maintenance, 1);

/**
 * GetMaintenanceResponse
 *
 * @generated from message tickettally.v1.GetMaintenanceResponse
 */
export type GetMaintenanceResponse = Message<"tickettally.v1.GetMaintenanceResponse"> & {
  /**
   * @generated from field: tickettally.v1.MaintenanceState state = 1;
   */
  state?: MaintenanceState;
};

/**
 * Describes the message tickettally.v1.GetMaintenanceResponse.
 * Use `create(GetMaintenanceResponseSchema)` to create a new message.
 */
export const GetMaintenanceResponseSchema: GenMessage<GetMaintenanceResponse> = /*@__PURE__*/
  messageDesc(file_v1_maintenance, 2);

/**
 * UpdateMaintenanceRequest carries the state to store. The environment field
 * of MaintenanceState is ignored on write.
 *
 * @generated from message tickettally.v1.UpdateMaintenanceRequest
 */
export type UpdateMaintenanceRequest = Message<"tickettally.v1.UpdateMaintenanceRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string from = 2;
   */
  from: string;

  /**
   * @generated from field: string to = 3;
   */
  to: string;
};

/**
 * Describes the message tickettally.v1.UpdateMaintenanceRequest.
 * Use `create(UpdateMaintenanceRequestSchema)` to create a new message.
 */
export const UpdateMaintenanceRequestSchema: GenMessage<UpdateMaintenanceRequest> = /*@__PURE__*/
  messageDesc(file_v1_maintenance, 3);

/**
 * UpdateMaintenanceResponse returns the state as stored, so the caller renders
 * what was actually written rather than what it hoped to write.
 *
 * @generated from message tickettally.v1.UpdateMaintenanceResponse
 */
export type UpdateMaintenanceResponse = Message<"tickettally.v1.UpdateMaintenanceResponse"> & {
  /**
   * @generated from field: tickettally.v1.MaintenanceState state = 1;
   */
  state?: MaintenanceState;
};

/**
 * Describes the message tickettally.v1.UpdateMaintenanceResponse.
 * Use `create(UpdateMaintenanceResponseSchema)` to create a new message.
 */
export const UpdateMaintenanceResponseSchema: GenMessage<UpdateMaintenanceResponse> = /*@__PURE__*/
  messageDesc(file_v1_maintenance, 4);

/**
 * MaintenanceService reads and writes the maintenance switch. Admin only.
 *
 * @generated from service tickettally.v1.MaintenanceService
 */
export const MaintenanceService: GenService<{
  /**
   * @generated from rpc tickettally.v1.MaintenanceService.GetMaintenance
   */
  getMaintenance: {
    methodKind: "unary";
    input: typeof GetMaintenanceRequestSchema;
    output: typeof GetMaintenanceResponseSchema;
  },
  /**
   * @generated from rpc tickettally.v1.MaintenanceService.UpdateMaintenance
   */
  updateMaintenance: {
    methodKind: "unary";
    input: typeof UpdateMaintenanceRequestSchema;
    output: typeof UpdateMaintenanceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_maintenance, 0);

